<script setup lang="ts">
import { asText, isFilled } from '@prismicio/client'
import type { Content } from "@prismicio/client";

const props = defineProps(getSliceComponentProps<Content.FullWidthHeroSlice>());

const buttons = computed(() => (props.slice.primary.buttons ?? []).filter(
  (b) => b && ('id' in b || 'url' in b),
))

function buttonClass(button: { variant?: string | null }): string {
  return button.variant === 'secondary'
    ? 'pa-btn pa-btn--secondary'
    : 'pa-btn pa-btn--primary'
}
</script>

<template>
  <section
      :data-slice-type="slice.slice_type"
      :data-slice-variation="slice.variation"
      :class="['pa-fwhero', 'pa-fwhero--' + slice.variation]"
  >
    <div class="pa-container">
      <div class="pa-fwhero__inner">
        <h2 v-if="isFilled.richText(slice.primary.heading)" class="pa-fwhero__heading">
          {{ asText(slice.primary.heading) }}
        </h2>
        <div v-if="isFilled.richText(slice.primary.description)" class="pa-fwhero__description">
          <PrismicRichText :field="slice.primary.description" />
        </div>
        <div v-if="buttons.length" class="pa-fwhero__buttons">
          <TrackedPrismicLink
              v-for="(button, index) in buttons"
              :key="index"
              :field="button"
              :track="slice.primary.cta_track_event"
              :class="buttonClass(button)"
          >
            {{ button.text || 'Meer info' }}
          </TrackedPrismicLink>
        </div>
      </div>
    </div>
  </section>
</template>
